<template>
  <div class="wrapper">
    <main-bar></main-bar>
    <main class="content" itemscope itemtype="http://schema.org/Article">
      <meta itemprop="inLanguage" content="de-DE" />
      <router-view></router-view>
    </main>
    <site-footer></site-footer>

        <svg class="svg-icon quarter-circle">
          <use xlink:href="/static/sprite.svg#quarter-circle" />
        </svg>
        <svg class="svg-icon quarter-circle-bordered">
            <use xlink:href="/static/sprite.svg#quarter-circle" />
        </svg>
        <svg class="svg-icon square-bordered">
            <use xlink:href="/static/sprite.svg#square" />
        </svg>
        <svg class="svg-icon square-colored">
            <use xlink:href="/static/sprite.svg#square" />
        </svg>
  </div>
</template>

<script>
import SelectCategory from './components/SelectCategory.vue'
import SiteFooter from './components/SiteFooter.vue'
import MainBar from './components/MainBar.vue'

export default {
  components: {
    SelectCategory,
    SiteFooter,
    MainBar
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue